import { useScrollReveal } from '../hooks/useScrollReveal';
import { useBooking } from '../context/BookingContext';

export default function FinalCTA() {
  const label = useScrollReveal(0);
  const heading = useScrollReveal(0.1);
  const sub = useScrollReveal(0.2);
  const cta = useScrollReveal(0.3);
  const { openModal } = useBooking();

  return (
    <section
      id="book"
      data-testid="final-cta-section"
      className="section-pad"
      style={{ backgroundColor: '#FDF6F4' }}
    >
      <div className="airmail-stripe-divider" style={{ marginBottom: 0 }} />

      <div className="container-miso" style={{ paddingTop: '80px', paddingBottom: '80px' }}>
        <div style={{ maxWidth: '580px', margin: '0 auto', textAlign: 'center' }}>

          <span ref={label.ref} style={label.style} className="section-label">
            Book Now
          </span>

          <h2
            ref={heading.ref}
            style={{ ...heading.style, marginBottom: '16px' }}
            className="h2-miso"
            data-testid="final-cta-heading"
          >
            April and May dates are{' '}
            <span className="italic-accent" style={{ color: '#B85C3A' }}>filling fast.</span>
          </h2>

          <p
            ref={sub.ref}
            style={{ ...sub.style, marginBottom: '40px' }}
            className="body-miso"
          >
            Only Miso Mini available to book right now. Takes 2 minutes to complete.
          </p>

          <div ref={cta.ref} style={cta.style}>
            <button
              onClick={openModal}
              data-testid="final-cta-btn"
              className="btn-primary"
              style={{ fontSize: '14px', padding: '16px 48px', marginBottom: '16px' }}
            >
              Book Miso Mini →
            </button>

            <div style={{ marginTop: '12px' }}>
              <a
                href="https://wa.me/918919174876?text=Hi%2C%20I%27d%20like%20to%20check%20availability%20for%20Miso%20Mini"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="final-cta-whatsapp-link"
                style={{
                  fontFamily: 'Graphik, sans-serif',
                  fontWeight: 400, fontSize: '14px',
                  color: '#9E8E7E', textDecoration: 'none',
                  transition: 'color 0.2s ease',
                }}
                onMouseEnter={e => e.target.style.color = '#B85C3A'}
                onMouseLeave={e => e.target.style.color = '#9E8E7E'}
              >
                Or check availability on WhatsApp →
              </a>
            </div>

            <div style={{ marginTop: '8px' }}>
              <a
                href="tel:+917013248755"
                data-testid="final-cta-phone"
                style={{
                  fontFamily: 'Graphik, sans-serif', fontWeight: 400,
                  fontSize: '14px', color: '#9E8E7E',
                  textDecoration: 'none',
                }}
              >
                +91 70132 48755
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
